import {Component, computed, DestroyRef, inject, input, viewChild, ChangeDetectionStrategy} from "@angular/core"
import {MaterialNode, MaterialSocketUiDefinition} from "@cm/material-nodes"
import {MaterialNodeIoComponent} from "@material-editor/components/sockets/material-node-io/material-node-io.component"
import {Socket, SocketPosition} from "@socket-editor/types"
import {SocketConnectionsService} from "@app/socket-editor/services/socket-connections.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-input-socket",
    imports: [MaterialNodeIoComponent],
    templateUrl: "./material-input-socket.component.html",
    styleUrl: "./material-input-socket.component.scss",
})
export class MaterialInputSocketComponent {
    public readonly $definition = input.required<MaterialSocketUiDefinition>({alias: "definition"})
    public readonly $defaultValue = input<unknown>(undefined, {alias: "defaultValue"})
    public readonly $material = input.required<MaterialNode>({alias: "material"})
    public readonly $nodeId = input.required<string>({alias: "nodeId"})
    public readonly $socket = computed<Socket>(() => {
        const definition = this.$definition()
        return {
            defaultValue: this.$defaultValue(),
            id: definition.name,
            inputField: !!definition.setting,
            label: definition.label,
            paramType: "socket",
            range: "range" in definition ? definition.range : null,
            type: "input",
            // TODO: actually evaluate the value
            value: this.$value() ?? this.$defaultValue(),
            valueType: definition.valueType,
        }
    })
    public readonly $value = input<unknown>(undefined, {alias: "value"})

    readonly $nodeIo = viewChild.required(MaterialNodeIoComponent)
    readonly connections = inject(SocketConnectionsService)
    readonly destroyRef = inject(DestroyRef)

    getSocketPosition(): SocketPosition {
        return this.$nodeIo().getSocketPosition()
    }
}
